export const STATUS_OPTIONS = [
  { value: '', label: 'Select status' },
  { value: '0', label: 'Draft' },
  { value: '1', label: 'Active' },
  { value: '2', label: 'Commissioned' },
  { value: '3', label: 'Decommissioned' },
] as const;
